import { useContext } from 'react';

import { IWebContext, WebContext } from '../components/contexts/WebContext';

// Extract only cart-related properties from WebContext
export type ICartContext = Pick<
  IWebContext,
  'min_order_amount' | 'webapp_out_of_delivery' | 'setWebappOutOfDelivery' | 'setMinOrderAmount'
>;

export const useCartContext = (): ICartContext => {
  const context = useContext(WebContext);

  if (!context)
    throw new Error('Esse componente deve ser usado dentro de um <WebContext> componente.');

  // Return only cart-related properties
  return {
    min_order_amount: context.min_order_amount,
    webapp_out_of_delivery: context.webapp_out_of_delivery,
    setWebappOutOfDelivery: context.setWebappOutOfDelivery,
    setMinOrderAmount: context.setMinOrderAmount,
  };
};
